import { createFileRoute, Outlet } from "@tanstack/react-router"
import { isNavigatingAway, redirectToLogin, sdk, untilPageUnloads } from "src/sdk"

let LOADED_ONCE = false

export const Route = createFileRoute("/_loggedIn")({
	component: Outlet,
	beforeLoad: async ({ context, location }) => {
		if (context.isLoggedIn) return

		// The login form lives on the API's host, so getting there is a page navigation rather than a route change.
		if (!isNavigatingAway() && !redirectToLogin(location.href)) {
			// The bounce guard tripped, so no navigation is coming. Throwing shows the failure instead of leaving the
			// route pending forever.
			throw new Error(
				"Signing in keeps failing: the browser has been sent to the login page repeatedly without a session " +
					"being established. Its cookies may be blocked for this site. Close this tab and try again from a new one.",
			)
		}

		// Awaiting a promise that never settles keeps this guard from returning and letting the router render the
		// protected view underneath while the browser is still tearing the page down.
		await untilPageUnloads()
	},
	loader: async () => {
		if (LOADED_ONCE) return

		await sdk.organizations.refreshStore()
		LOADED_ONCE = true

		return
	},
})
